import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import { ResponseAddDto, ResponseListingPerformance, ResponsePerformance } from "../../../shared/nestjs/gd-integrated/dto/performance-planning.dto";
import { PerformancePlanningApi } from "../../../shared/nestjs/gd-integrated/services/performance-planning.api";

@Injectable()
export class PerformancePlanningBloc {

  constructor(
    public performancePlanningApi: PerformancePlanningApi,
  ) {
  }

  add(data): Observable<ResponseAddDto> {
		return this.performancePlanningApi.add(data);
	}

	saveRevision(data): Observable<ResponseAddDto> {
		return this.performancePlanningApi.saveRevision(data);
	}

	// delete(data): Observable<ResponseDeleteDto> {
	// 	return this.performancePlanningApi.delete(data);
  // }

  listing(params, page, limit): Observable<ResponseListingPerformance> {
    console.log('BLOC listing', params, page, limit)
		return this.performancePlanningApi.listing(params, page, limit);
  }
  
  history(requestNo, periodCode, empId, referenceDate, formNo): Observable<any> {
		return this.performancePlanningApi.history(requestNo, periodCode, empId, referenceDate, formNo);
  }

  revisionHistory(formNo): Observable<ResponsePerformance> {
		return this.performancePlanningApi.revisionHistory(formNo);
  }

  empData(periodCode, empId): Observable<ResponsePerformance> {
		return this.performancePlanningApi.empData(periodCode, empId);
  }

  libraryKPI(textSearch, limit, skip, kpiCode): Observable<ResponsePerformance> {
		return this.performancePlanningApi.libraryKPI(textSearch, limit, skip, kpiCode);
  }

  checkKPICode(kpiCode): Observable<ResponsePerformance> {
		return this.performancePlanningApi.checkKPICode(kpiCode);
  }

  revisionDetail(requestNo, periodCode, empId, formNo, reviewerEmpid): Observable<any> {
		return this.performancePlanningApi.revisionDetail(requestNo, periodCode, empId, formNo, reviewerEmpid);
  }

  addCascade(data): Observable<ResponseAddDto> {
		return this.performancePlanningApi.addCascade(data);
	}

  cascadeHistory(data): Observable<ResponseAddDto> {
		return this.performancePlanningApi.cascadeHistory(data);
	}

  addEmpCascade(data): Observable<ResponseAddDto> {
		return this.performancePlanningApi.addEmpCascade(data);
	}

  getEmpCascade(data): Observable<ResponseAddDto> {
		return this.performancePlanningApi.getEmpCascade(data);
	}

  showButton(requestNo, empId, periodCode, formNo): Observable<ResponsePerformance> {
		return this.performancePlanningApi.showButton(requestNo, empId, periodCode, formNo);
  }

  performancePlanRequest(requestNo): Observable<ResponsePerformance> {
		return this.performancePlanningApi.performancePlanRequest(requestNo);
  }
}



// WEBPACK FOOTER //
// ./src/bloc/hr/performance-sf6/performance-planning.bloc.ts